import { render, staticRenderFns } from "./LaudoTecnicoAgricolaModal.vue?vue&type=template&id=8b8c4f94&scoped=true&lang=pug"
import script from "./LaudoTecnicoAgricolaModal.vue?vue&type=script&lang=js"
export * from "./LaudoTecnicoAgricolaModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoTecnicoAgricolaModal.vue?vue&type=style&index=0&id=8b8c4f94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8c4f94",
  null
  
)

export default component.exports